
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Nav, Collapse } from "reactstrap";

var ps;

const Sidebar = (props) => {
  const [state, setState] = React.useState({});
  const[selectName,setSelectName] = React.useState(null);
  const sidebarRef = React.useRef(null);
  const location = useLocation();
  React.useEffect(() => {
    setState(getCollapseStates(props.routes));
  }, []);
  React.useEffect(() => {
    // if you are using a Windows Machine, the scrollbars will have a Mac look
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebarRef.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
    }
    return function cleanup() {
      // we need to destroy the false scrollbar when we navigate
      // to a page that doesn't have this component rendered
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });
  // this creates the intial state of this component based on the collapse routes
  // that it gets through props.routes
  // function showStuff(id) {
  //   alert(id + " is");
  //   document.getElementById(id).addClass = 'show';
  // }
  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
     
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };


 
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
   
    
    const { rtlActive } = props;
    return routes.map((prop, key) => {
      
      if(prop.name!==""){
      
      if (prop.redirect) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        
        return (
          <li
            className={getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
                      
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={state[prop.state]}
              id={prop["state"]}
              onClick={(e) => {
              //  console.log("---getting",e.target.innerText);
                e.preventDefault();
                // setSelectName(e.target.innerText);
                // console.log(prop["state"]);

                if(prop.isChild==="1"){
                  setState({ ...state, ...st });
                }else {
                  setState({ ...st });
                }

                
             
              // showStuff(prop["state"]); 
              // return false;
              
            }}
            >
              {prop.icon !== undefined ? (
                <>
                  <img src={prop.icon}  width="34px" height="34px" /> 
                  <p className="sidebar-normal">
                    {rtlActive ? prop.rtlName : prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">
                    {rtlActive ? prop.rtlMini : prop.mini}
                  </span>
                  <span className="sidebar-normal">
                    {rtlActive ? prop.rtlName : prop.name}
                    <b className="caret" />
                  </span>
                </>
              )}
            </a>
            {/* {console.log("----1-",prop.name.toLowerCase(),"----",selectName?.toLowerCase())}
            <Collapse isOpen={prop.name.toLowerCase()==selectName?.toLowerCase()?true:false}>
              
              <ul className="nav">{createLinks(prop.views)}</ul>
            </Collapse> */}
            {/* {console.log("----2-",prop.state)}
            {console.log("----33-",state[prop.state])} */}

            <Collapse isOpen={state[prop.state]} >
              <ul className="nav">{createLinks(prop.views)}</ul>
            </Collapse>

          </li>
        );

      }
      return (
        <li className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to={prop.layout + prop.path}
            activeClassName=""
            onClick={props.closeSidebar}
          >
            {prop.icon !== undefined ? (
              <>
              
              <img src={prop.icon}  width="34px" height="34px" className="menuimg"/>    
                <p className="sidebar-normal">{rtlActive ? prop.rtlName : prop.name}</p>
              </>
            ) : (
              <>
                <span className="sidebar-mini-icon">
                  {rtlActive ? prop.rtlMini : prop.mini}
                </span>
                <span className="sidebar-normal">
                  {rtlActive ? prop.rtlName : prop.name}
                </span>
              </>
            )}
          </NavLink>
        </li>
      );
            }
    });
  };
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const { activeColor, logo } = props;
  let logoImg = null;
  let logoText = null;
  if (logo !== undefined) {
    if (logo.outterLink !== undefined) {
      logoImg = (
        <a
          href={logo.outterLink}
          className="simple-text logo-mini"
          onClick={props.closeSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo" />
          </div>
        </a>
      );
      logoText = (
        <a
          href={logo.outterLink}
          className="simple-text logo-normal"
          onClick={props.closeSidebar}
        >
          {logo.text}
        </a>
      );
    } else {
      logoImg = (
        <NavLink
          to={logo.innerLink}
          className="simple-text logo-mini"
          onClick={props.closeSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo" />
          </div>
        </NavLink>
      );
      logoText = (
        <NavLink
          to={logo.innerLink}
          className="simple-text logo-normal"
          onClick={props.closeSidebar}
        >
          {logo.text}
        </NavLink>
      );
    }
  }

  
  const { activeColor1, logo1 } = props;
  let logo1Img = null;
  let logo1Text = null;
  if (logo1 !== undefined) {
    if (logo1.outterLink !== undefined) {
      logo1Img = (
        <a
          href={logo1.outterLink}
          className="simple-text logo-mini"
          target="_blank"
          onClick={props.closeSidebar}
        >
          <div className="logo-img">
            <img src={logo1.imgSrc} alt="react-logo" />
          </div>
        </a>
      );
      logo1Text = (
        <a
          href={logo1.outterLink}
          className="simple-text logo-normal"
          target="_blank"
          onClick={props.closeSidebar}
        >
          {logo1.text}
        </a>
      );
    } else {
      logo1Img = (
        <NavLink
          to={logo1.innerLink}
          className="simple-text logo-mini"
          onClick={props.closeSidebar}
        >
          <div className="logo-img">
            <img src={logo1.imgSrc} alt="react-logo" />
          </div>
        </NavLink>
      );
      logo1Text = (
        <NavLink
          to={logo1.innerLink}
          className="simple-text logo-normal"
          onClick={props.closeSidebar}
        >
          {logo1.text}
        </NavLink>
      );
    }
  }
  return (
    <div className="sidebar" data={activeColor}>
      <div className="sidebar-wrapper" ref={sidebarRef}>
        {logoImg !== null || logoText !== null ? (
          <div className="logo">
            {logoImg}
            {logoText}
          </div>
        ) : null}
        <Nav>{createLinks(props.routes)}</Nav>

        {logo1Img !== null || logo1Text !== null ? (
          <div className="logo">
            {logo1Img}
            {logo1Text}
          </div>
        ) : null}
      </div>
    </div>
  );
};



export default Sidebar;
